import "core-js/modules/es.array.push.js";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-b2c5380c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "modules-header"
};
var _hoisted_2 = {
  class: "modules-title"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "订购记录", -1);
});
var _hoisted_4 = {
  class: "package-list"
};
var _hoisted_5 = ["title", "onClick"];
var _hoisted_6 = {
  class: "package-item-wrapper"
};
var _hoisted_7 = {
  class: "package-title"
};
var _hoisted_8 = {
  class: "package-type-price"
};
var _hoisted_9 = {
  class: "package-type"
};
var _hoisted_10 = {
  class: "package-price"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "￥", -1);
});
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "package-button"
  }, "立即购买", -1);
});
var _hoisted_13 = {
  class: "app-scene"
};
var _hoisted_14 = ["title", "onClick"];
var _hoisted_15 = {
  class: "package-item-wrapper"
};
var _hoisted_16 = {
  class: "package-title"
};
var _hoisted_17 = {
  class: "package-type-price"
};
var _hoisted_18 = {
  class: "package-type"
};
var _hoisted_19 = {
  class: "package-price"
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "￥", -1);
});
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "package-button"
  }, "立即购买", -1);
});
var _hoisted_22 = {
  class: "app-scene"
};
import { reactive, ref, h } from "vue";
import { showConfirmDialog, showDialog, showToast } from "vant";
import router from "@/router";
import { isWeChat } from "@/common/utils";
import { apiOrderPackageCheck, apiGetPackageStyleList } from "@/common/api";
import CornerMark from "./CornerMark.vue";
import appViewIcon from "@/assets/images/app_view_icon.png";
import fiery from "@/assets/images/fiery.png";
import hot from "@/assets/images/hot.png";
import recommend from "@/assets/images/recommend.png";
export default /*#__PURE__*/_defineComponent({
  __name: 'PackageList',
  props: {
    iccid: null,
    message: null
  },
  setup: function (__props) {
    var props = __props;
    var active = ref('1');
    var showTypeFlag = ref(false);
    var cornerMarkMap = new Map([[0, undefined], [1, {
      src: recommend,
      alt: "推荐"
    }], [2, {
      src: hot,
      alt: "HOT"
    }], [3, {
      src: fiery,
      alt: "火爆"
    }], [4, {
      src: appViewIcon,
      alt: "App使用场景"
    }]]);
    function getCornerMark(key) {
      return cornerMarkMap.get(key);
    }
    var packageList = ref([]);
    var loading = ref(false);
    var finished = ref(false);
    function orderRecords() {
      router.push({
        path: "/order-records",
        query: {
          iccid: props.iccid
        }
      });
    }
    function tips() {
      showDialog({
        title: "订购流量",
        message: function () {
          return h("ul", {
            style: {
              textAlign: "left",
              lineHeight: 1.6
            }
          }, __spreadArray([], props.message.map(function (item) {
            return h("li", {
              style: {
                padding: "4px 0"
              }
            }, item);
          }), true));
        }
      });
    }
    function getPackageButtonState(record) {
      if (record.purchasedFlag === 1) {
        return "disabled";
      }
      if (record.billType === "3") {
        return "appreciation";
      }
      return "basic";
    }
    function buyPackage(record) {
      if (getPackageButtonState(record) === "disabled") {
        showToast("该套餐不可购买");
        return;
      }
      apiOrderPackageCheck({
        iccid: props.iccid
      }).then(function (res) {
        console.log("🚀 ~ apiOrderPackageCheck ~ res:", res);
        var code = res.code,
          data = res.data;
        if (code !== 0) {
          showToast(res.msg);
          return;
        }
        var popupType = data.popupType,
          popupTitle = data.popupTitle,
          popupContent = data.popupContent,
          haveCancelButton = data.haveCancelButton,
          button = data.button;
        if (popupType === "1") {
          var packageId = record.packageId,
            id = record.id;
          router.push({
            path: "/package-buy",
            query: {
              packageId: packageId,
              iccid: props.iccid,
              id: id
            }
          });
        } else if (popupType === "2") {
          showConfirmDialog({
            title: popupTitle,
            message: popupContent,
            showCancelButton: haveCancelButton,
            confirmButtonText: button.buttonTitle,
            beforeClose: function (action) {
              return new Promise(function (resolve) {
                if (action === "confirm" && button.path) {
                  window.location.href = button.path;
                }
                resolve(true);
              });
            }
          });
        }
      });
    }
    var pageParams = reactive({
      pageNo: 1,
      pageSize: 10
    });
    function handleGetPackageList() {
      loading.value = true;
      return new Promise(function (resolve, reject) {
        apiGetPackageStyleList(__assign({
          iccid: props.iccid
        }, pageParams)).then(function (res) {
          if (res.code === 0) {
            resolve(res);
            if (res.data.packageDateList.length < pageParams.pageSize) {
              finished.value = true;
            }
          } else {
            finished.value = true;
            reject(res);
          }
        }).catch(function (err) {
          reject(err);
          finished.value = true;
        }).finally(function () {
          loading.value = false;
        });
      });
    }
    function getPackageList() {
      pageParams.pageNo = 1;
      handleGetPackageList().then(function (res) {
        console.log('data......', res.data);
        if (res.data.showType == 1) {
          packageList.value = res.data.headGroupPackageDataList;
          showTypeFlag.value = true;
        } else {
          packageList.value = res.data.packageDateList;
        }
        console.log(packageList.value);
      });
    }
    function loadPackageList() {
      pageParams.pageNo++;
      handleGetPackageList().then(function (res) {
        var _a;
        console.log('res...', res);
        (_a = packageList.value).push.apply(_a, res.data.packageDateList);
      });
    }
    getPackageList();
    return function (_ctx, _cache) {
      var _component_van_icon = _resolveComponent("van-icon");
      var _component_van_list = _resolveComponent("van-list");
      var _component_van_tab = _resolveComponent("van-tab");
      var _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode(" 订购流量 "), _createVNode(_component_van_icon, {
        style: {
          "margin-left": "6px"
        },
        name: "question-o",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return tips();
        })
      })]), _unref(isWeChat)() ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "order-record",
        onClick: orderRecords
      }, [_hoisted_3, _createVNode(_component_van_icon, {
        name: "arrow",
        style: {
          "margin-left": "2px"
        },
        size: "14"
      })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [showTypeFlag.value ? (_openBlock(), _createBlock(_component_van_tabs, {
        key: 0,
        active: active.value,
        "onUpdate:active": _cache[2] || (_cache[2] = function ($event) {
          return active.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageList.value, function (item, index) {
            return _openBlock(), _createBlock(_component_van_tab, {
              title: item.head,
              key: index
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_van_list, {
                  loading: loading.value,
                  "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) {
                    return loading.value = $event;
                  }),
                  finished: finished.value,
                  onLoad: loadPackageList,
                  offset: "-120",
                  "finished-text": "没有更多了"
                }, {
                  default: _withCtx(function () {
                    return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.packageList, function (i, index) {
                      return _openBlock(), _createElementBlock("div", {
                        class: "package-item",
                        key: index,
                        title: i,
                        onClick: function ($event) {
                          return buyPackage(i);
                        }
                      }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(i.agentPackageName), 1), _createElementVNode("div", {
                        class: _normalizeClass(["package-info", getPackageButtonState(i)])
                      }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(i.billType === "3" ? "加餐包" : "基础包"), 1), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createTextVNode(_toDisplayString(i.agentSalePriceShow), 1)])]), _hoisted_12], 2)]), _createElementVNode("div", _hoisted_13, [_createVNode(CornerMark, {
                        cornerInfo: getCornerMark(i.cornerMark)
                      }, null, 8, ["cornerInfo"])])], 8, _hoisted_5);
                    }), 128))];
                  }),
                  _: 2
                }, 1032, ["loading", "finished"])];
              }),
              _: 2
            }, 1032, ["title"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["active"])) : (_openBlock(), _createBlock(_component_van_list, {
        key: 1,
        loading: loading.value,
        "onUpdate:loading": _cache[3] || (_cache[3] = function ($event) {
          return loading.value = $event;
        }),
        finished: finished.value,
        onLoad: loadPackageList,
        offset: "-120",
        "finished-text": "没有更多了"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageList.value, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "package-item",
              key: item,
              title: item,
              onClick: function ($event) {
                return buyPackage(item);
              }
            }, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(item.agentPackageName), 1), _createElementVNode("div", {
              class: _normalizeClass(["package-info", getPackageButtonState(item)])
            }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(item.billType === "3" ? "加餐包" : "基础包"), 1), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createTextVNode(_toDisplayString(item.agentSalePriceShow), 1)])]), _hoisted_21], 2)]), _createElementVNode("div", _hoisted_22, [_createVNode(CornerMark, {
              cornerInfo: getCornerMark(item.cornerMark)
            }, null, 8, ["cornerInfo"])])], 8, _hoisted_14);
          }), 128))];
        }),
        _: 1
      }, 8, ["loading", "finished"]))])], 64);
    };
  }
});